import type { InternalDropdownOption } from '~/chords/DropdownSingleSelect/types';

/**
 * Update isVisible=true for all options.
 * @param options - The options to update.
 * @returns The updated options.
 */
export function updateIsVisibleTrue(
  options: InternalDropdownOption[],
): InternalDropdownOption[] {
  return options.map(
    (option): InternalDropdownOption => ({
      ...option,
      isVisible: true,
    }),
  );
}
